// The account feature: profile and preferences pages in the user menu, preferences saved for every
// device. Other features use its public hooks only.
import { SlidersHorizontalIcon, UserRoundIcon } from "lucide-react";
import { registerShellMount } from "../../app/registry/mounts";
import { registerNav } from "../../app/registry/nav";
import { PreferencesSync } from "./preferences-sync";

registerNav({
  id: "account:profile",
  group: "account",
  labelKey: "account.profile.nav",
  icon: UserRoundIcon,
  to: "/account/profile",
  order: 10,
});
registerNav({
  id: "account:preferences",
  group: "account",
  labelKey: "account.preferences.nav",
  icon: SlidersHorizontalIcon,
  to: "/account/preferences",
  order: 20,
});
registerShellMount({ id: "account:preferences-sync", component: PreferencesSync });

export { usePreferences, useUpdatePreferences } from "./api";
export { useFavorites } from "./favorites";
